import React from 'react';
import classNames from 'classnames';
import { NativeProps } from '@/src/components/interfaces';

export enum CSkeletonVariant {
  Text = 'text',
  Circular = 'circular',
  Rectangular = 'rectangular',
}

export interface CSkeletonProps extends NativeProps {
  variant?: CSkeletonVariant;
  width?: string | number;
  height?: string | number;
  animated?: boolean;
}

export function CSkeleton(props: CSkeletonProps): React.JSX.Element {
  const variant = props.variant ?? CSkeletonVariant.Rectangular;
  const animated = props.animated ?? true;

  const borderRadius = variant === CSkeletonVariant.Circular ? 'round' : variant === CSkeletonVariant.Text ? 'sm' : 'md';

  const style: React.CSSProperties = { ...props.style };
  if (props.width) style.width = props.width;
  if (props.height) style.height = props.height;
  if (variant === CSkeletonVariant.Text && !props.height) style.height = '1em';
  if (variant === CSkeletonVariant.Circular) {
    if (!props.width) style.width = props.height ?? '40px';
    if (!props.height) style.height = props.width ?? '40px';
  }

  return (
    <div
      id={props.id}
      style={style}
      className={classNames('c-skeleton', `c-skeleton--border-radius-${borderRadius}`, props.class)}
      data-test-selector="c-skeleton"
    >
      {animated && <div className="c-skeleton__pulse" />}
    </div>
  );
}
